import { EDjangoAppsEndpoints } from '../enums/EDjangoAppsEndpoints';
import { type CachedAPIResponse } from '../models/CachedAPIResponse';
import { type IOpsPerformancePositionsDTO } from '../models/IOpsPerformancePositionsDTO';
import { type IOpsPerformanceStatsDTO } from '../models/IOpsPerformanceStatsDTO';
import { type ISortingMeta } from '../models/ISortingMeta';
import { type PorftfolioManagementHedgeStatsDTO } from '../models/PortfolioManagementHedgeStatsDTO';
import { type TPageSize } from '../models/TPageSize';
import { type TPandasTable } from '../models/TPandasTable';
import CoreJsonAPIService from './CoreJsonAPIService';

export class SvPortfolioManagementServices extends CoreJsonAPIService {
  static async getStatistics(params: { factsheetID: string }) {
    return await super.get<CachedAPIResponse<IOpsPerformanceStatsDTO>>(
      EDjangoAppsEndpoints.opsNews,
      'performance/stats',
      {
        factsheetID: params.factsheetID
      }
    );
  }

  static async getPositions(params: {
    factsheetID: string;
    page: number;
    search: string;
    sorting: ISortingMeta;
    pageSize: TPageSize;
  }) {
    return await super.get<CachedAPIResponse<IOpsPerformancePositionsDTO>>(
      EDjangoAppsEndpoints.opsNews,
      'performance/positions',
      {
        factsheetID: params.factsheetID,
        page: params.page,
        searchText: params.search,
        sortCol: params.sorting.sortCol,
        ascending: params.sorting.ascending,
        pageSize: params.pageSize
      }
    );
  }

  static async getHedgeStatistics(params: { factsheetID: string; date: number }) {
    return await super.get<PorftfolioManagementHedgeStatsDTO>(EDjangoAppsEndpoints.opsNews, 'hedge/stats', {
      factsheetID: params.factsheetID,
      date: params.date
    });
  }

  static async getHedgeSummary(params: { factsheetID: string; date: number }) {
    return await super.get<{ asOfDateSec: number; summary: TPandasTable }>(
      EDjangoAppsEndpoints.opsNews,
      'hedge/summary',
      {
        factsheetID: params.factsheetID,
        date: params.date
      }
    );
  }

  static async getHedgeMissingDates(params: { factsheetID: string }) {
    return await super.get<CachedAPIResponse<{ missing_dates: number[] }>>(
      EDjangoAppsEndpoints.opsNews,
      'hedge/missing-dates',
      {
        factsheetID: params.factsheetID
      }
    );
  }
}
